import { ColorSet } from './color'
import { TypographySet } from './typography'

import { theme } from '@/shared/design-system/theme'

export interface CellTheme {
  colors: ColorSet
  typography: TypographySet
}

const cellTheme = {
  ...theme,
}

export default cellTheme
